<div class="grid grid-cols-1">
  <div class="flex flex-col gap-2">
    <label for="pesel">PESEL</label>
    <input
      id="pesel"
      pInputText
      appControlError
      [maxlength]="11"
      [formControl]="formGroup().controls.pesel"
    />
  </div>

  <div class="flex flex-col gap-2">
    <label for="email">Adres e-mail</label>
    <input
      id="email"
      pInputText
      [formControl]="formGroup().controls.email"
      appControlError
    />
  </div>

  <div class="flex flex-col gap-2">
    <span id="role">Rola</span>
    <p-select
      ariaLabelledBy="role"
      class="w-full"
      [options]="oganizationMemberRoleItems"
      optionLabel="label"
      optionValue="value"
      placeholder="Wybierz rolę"
      appControlError
      appendTo="body"
      [formControl]="formGroup().controls.rola"
    />
  </div>

  @if (
    this.formGroup().controls.rola.value === RolaReprezentantaOrganizacji.OUP
  ) {
    <p-card header="Instytucje">
      <div class="wide">
        <p-table
          [value]="this.formGroup().controls.instytucje.controls"
          [paginator]="false"
          styleClass="customPrimeTable"
        >
          <ng-template #header>
            <tr>
              <th style="width: 2rem; text-align: center">Wybierz</th>
              <th>Nazwa</th>
            </tr>
          </ng-template>

          <ng-template #body let-instytucja let-i="rowIndex">
            <tr>
              <td style="width: 2rem; text-align: center">
                <p-checkbox
                  binary="true"
                  [inputId]="'inst-' + i"
                  [formControl]="instytucja.controls.selected"
                >
                </p-checkbox>
              </td>
              <td>
                <label [for]="'inst-' + i">
                  {{ instytucja.controls?.identyfikator?.value }}:
                  {{ instytucja.controls?.nazwa?.value }}
                </label>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
    <div class="mt-2 p-2">
      <app-error-summary
        [errors]="formGroup().errors | errorMessages"
      ></app-error-summary>
    </div>
  }
  <p-card header="Pełnomocnictwo">
    <p-table
      [value]="attachments()"
      [paginator]="false"
      styleClass="customPrimeTable"
    >
      <ng-template #header>
        <tr>
          <th style="width: 20%">Nazwa</th>
          <th style="width: 20%">Data przesłania</th>
          <th style="width: 1%">Akcje</th>
        </tr>
      </ng-template>
      <ng-template #body let-file let-i="rowIndex">
        <tr class="border-b text-sm">
          <td class="py-2">
            {{ (file.file ?? file).name }}
          </td>
          <td class="py-2">
            {{ file.uploadedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
          </td>
          <td class="py-2">
            <div class="flex gap-3 justify-center">
              <button
                type="button"
                class="text-blue-600 icon cursor-pointer"
                (click)="removeFile(i)"
              >
                <i class="pi pi-trash"></i>
              </button>
              <button
                type="button"
                class="text-blue-600 icon cursor-pointer"
                (click)="downloadFile(file)"
              >
                <i class="pi pi-download"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex mt-4">
      <button type="button">
        <p-fileUpload
          mode="basic"
          chooseIcon="pi pi-upload"
          chooseLabel="Dodaj pełnomocnictwo"
          cancelLabel="Anuluj"
          aria-label="Dodaj pełnomocnictwo"
          styleClass="customFileupload"
          [auto]="true"
          [multiple]="false"
          [customUpload]="true"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [maxFileSize]="1000000"
          [invalidFileSizeMessageSummary]="'{0}:'"
          [invalidFileSizeMessageDetail]="'Nieprawidłowy rozmiar pliku. Maksymalny rozmiar: 1 MB.'"
          (onSelect)="onAddFile($event)"
        >
        </p-fileUpload>
      </button>
    </div>
  </p-card>
  <div class="flex justify-end gap-5 mt-5">
    <p-button
      label="Anuluj"
      styleClass="customInfoButton outlined"
      (click)="dynamicDialogRef.close()"
    />
    <p-button
      label="Dodaj użytkownika"
      styleClass="customInfoButton"
      (click)="addOrganizationMember()"
    />
  </div>
</div>
